import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import MeetingDetailInline from "@/components/MeetingDetailInline";

export default function MeetingPage() {
  const { mid } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [projectMembers, setProjectMembers] = useState([]);
  const [myPerms, setMyPerms] = useState([]);

  const load = async () => {
    const { data } = await api.get(`/meetings/${mid}`);
    setData(data);
    const pid = data.meeting.project_id;
    const wsid = data.meeting.workspace_id;
    if (pid) {
      // Project-scoped meeting: resolve project members + perms.
      const [pm, perms] = await Promise.all([
        api.get(`/projects/${pid}/members`).catch(() => ({ data: [] })),
        api.get(`/projects/${pid}/my-permissions`).catch(() => ({ data: { permissions: [] } })),
      ]);
      setProjectMembers(pm.data || []);
      setMyPerms(perms.data?.permissions || []);
    } else if (wsid) {
      // Feb 2026 R293g · Workspace-scoped meeting (no project): pull
      // workspace-level perms so Status pill, Agenda add, Action-item
      // add, Save-notes etc. stay visible for workspace members.
      const [wm, perms] = await Promise.all([
        api.get(`/workspaces/${wsid}/members`).catch(() => ({ data: [] })),
        api.get(`/workspaces/${wsid}/my-permissions`).catch(() => ({ data: { permissions: [] } })),
      ]);
      setProjectMembers(wm.data || []);
      setMyPerms(perms.data?.permissions || []);
    }
  };
  useEffect(() => { load(); }, [mid]);

  if (!data) {
    return <div className="p-8 text-sm text-muted-foreground">Loading meeting…</div>;
  }
  const m = data.meeting;

  return (
    <div className="px-4 sm:px-6 md:px-10 py-6">
      <div className="flex items-center gap-2 mb-4">
        <Button size="sm" variant="ghost" className="rounded-none" onClick={() => nav(-1)} data-testid="meeting-back-btn">
          <ArrowLeft className="w-3.5 h-3.5 mr-1.5" /> Back
        </Button>
        {m.project_id && (
          <Link to={`/app/projects/${m.project_id}`} className="text-xs text-muted-foreground hover:text-primary">
            ← project
          </Link>
        )}
      </div>
      <MeetingDetailInline
        meetingId={mid}
        projectMembers={projectMembers}
        myPerms={myPerms}
        onChanged={load}
      />
    </div>
  );
}
